var bighouse = bighouse || {};

bighouse.textimage = (function () {

    function init() {

        if( $('.js-textImageCarousel').length === 0)
            return;
        
        $('.js-textImageCarousel').each(function(e){
            if( $(this).find('picture').length > 1){
                $(this).slick({
                    fade: true,
                    arrows: false,
                    autoplay: true,
                    speed: 2000,
                    autoplaySpeed: 4000
                });
            }

        });
    }


    



    return {
        init: init
    };
})();